<template>
  <Modal :title="title" :showModal="showModal" :class="`design-idea-template-modal design-idea-form ${action}`" @submit="submit">
    <template v-slot:body>
      <div class="d-flex design-idea-container">
        <div class="left-sidebar scrollbar overflow-x-hidden">
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0 font-weight-bold">Name*</label>
            <input class="form-control mt-2" type="text" v-model="data.name" />
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0 font-weight-bold">SKU</label>
            <input class="form-control mt-2" type="text" v-model="data.sku" />
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0 font-weight-bold">Description*</label>
            <textarea class="form-control mt-2" v-model="data.description"></textarea>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0 font-weight-bold">Category*</label>
            <Select class="mt-2" source="term/search" v-model="data.term_ids" multiple></Select>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0 font-weight-bold">Tags</label>
            <Select class="mt-2" v-model="data.tags" multiple taggable></Select>
          </div>
          <div class="position-relative form-group col-12">
            <label class="col-12 mb-0 p-0 font-weight-bold">Attachment</label>
            <ButtonUpload :config="{ multiple: true }" v-model="data.thumbnails" class="mt-2"></ButtonUpload>
          </div>
          <div class="position-relative form-group col-12 clearfix">
            <label class="col-12 mb-0 p-0 font-weight-bold">Samples</label>
            <template v-for="(sample, index) in data?.samples" :key="index">
              <input class="form-control mt-2" type="text" :value="sample" @input="data.samples[index] = $event.currentTarget.value" placeholder="URL" />
            </template>
            <button type="button" class="btn float-right mt-2 btn-outline-success" @click.stop.prevent="addMoreSample">Add new</button>
          </div>
          <div class="position-relative form-group col-12 clearfix">
            <label class="col-12 mb-2 p-0 font-weight-bold">Designer</label>
            <Select source="user/search" type="auto" field="design.designer_read" placeholder="Designer" data-title="Designer" class="has-tip" v-model="data.designer_id"></Select>
          </div>
          <div class="position-relative form-group col-12 clearfix">
            <label class="col-12 mb-2 p-0 font-weight-bold">Priority</label>
            <Select :options="listPriority" placeholder="Priority" v-model="data.priority"></Select>
          </div>
        </div>
        <div class="main-design-idea main-thumbnail-preview">
          <Gallery :value="galleryConfig.gallery" :groups="galleryConfig.groups" :config="galleryConfig.config" @changeValue="handleChangeGalleryValue"></Gallery>
        </div>
        <div class="right-sidebar scrollbar overflow-x-hidden">
          <Comment :config="data"></Comment>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
import ButtonUpload from '@/components/ButtonUpload.vue'
import Gallery from '@/components/Gallery.vue'
import View from './View.vue'
export default {
  extends: View,
  mixins: [Event],
  components: {
    ButtonUpload,
    Gallery
  },
  data() {
    return {
      modal: false,
      data: {}
    }
  },
  computed: {
    title() {
      return this.data.status == 'draft' ? 'Create Idea' : 'Edit Idea'
    },
    storeId() {
      return this.config?.storeId
    },
    action() {
      return 'edit'
    },
    getUri() {
      return `design-idea/get/${this.designIdeaId}`
    },
    submitUri() {
      return `design-idea/update/${this.designIdeaId}`
    },
    more() {
      return this.data.more
    },
    listPriority() {
      return Object.values(this.more?.priority || [])
    },
    galleryConfig() {
      let groups = {
        gallery: {
          label: 'Gallery',
          priority: 10
        },
        blueprint: {
          label: 'Blueprint',
          priority: 15
        }
      }
      let gallery = []
      Object.values(this.data.thumbnails || []).forEach((value, index) => {
        gallery.push({
          items: value?.files || value,
          status: value?.status || null,
          uploaded: value?.uploaded || false,
          index,
          group: 'gallery'
        })
      })
      Object.values(this.data.designs || []).forEach((value, index) => {
        gallery.push({
          items: value?.files || value,
          status: value?.status || null,
          uploaded: value?.uploaded || false,
          index,
          group: 'blueprint'
        })
      })
      return {
        gallery,
        groups,
        config: {
          fullScreen: true,
          background: true,
          thumbnail: true,
          editable: ['draft', 'un-assigned', 'confirm'].includes(this.data.status),
          default: {
            selected: {
              group: 'gallery'
            }
          }
        }
      }
    }
  },
  created() {
    this.store.commit(['data'], {})
    this.selectedThumbnailPreview = 0
  },
  methods: {
    addMoreSample() {
      this.data.samples.push('')
    },
    handleChangeGalleryValue(values) {
      let images = {}
      values.forEach((item) => {
        if (!images?.[item.key || 'default']) {
          images[item.key || 'default'] = {}
        }
        if (!images?.[item.key || 'default']?.[item.group]) {
          images[item.key || 'default'][item.group] = []
        }
        images[item.key || 'default'][item.group].push(item.items)
      })
      this.data.thumbnails = images?.default?.gallery || []
      this.data.designs = images?.default?.blueprint || []
    },
    setUpData({ status, data }) {
      if (status == 'success') {
        this.showModal = true
        this.data = data
      }
    },
    submit() {
      let data = {
        name: this.data.name,
        sku: this.data.sku,
        description: this.data.description,
        term_ids: this.data.term_ids,
        tags: this.data.tags,
        samples: this.data.samples,
        thumbnails: this.data.thumbnails,
        designer_id: this.data.designer_id,
        priority: this.data.priority
      }
      this.submitForm(data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.design-idea-template-modal.create,
.design-idea-template-modal.edit {
  .main-design-idea,
  .left-sidebar,
  .right-sidebar {
    height: calc(100vh - 132px);
  }
  .main-design-idea {
    flex: 1;
    .gallery-container {
      height: 100%;
    }
  }
}
</style>
